export const tabbarHeight: number = 48;
